<template>
    <span class="projectContent">
        <h1 class="projectTitle">
            Horror Ride
        </h1>
        <h2 class="projectSubTitle">
           Course Work of BVW Created in Just Two Weeks
        </h2>
        <p>
             Yihua Pu (Sound Designer + Producer), Marsh He (Artist), Iris Zhang (Artist), <u>Bonny Wang</u> (Programmer),  Tyler Yang (Programmer)
        </p>
        <h4>
            Description:
        </h4>
        <p>
           Experience heart-pounding terror as you sit in an egg chair with Quest 3, exploring a haunted house and desperately evading vengeful spirits in this spine-tingling horror ride.
            
        </p>
        <h4>
            Technologies Used:
        </h4>
        <p>
            Quest 3, Egg Chair| 1 Player
            <br>
            <br>
            Google Firebase realtime database for multidevice communication

        </p>
        <h4>
            Game Screenshots:
        </h4>
        <img width="80%" src="ImgOriginal/Horror.png">
        <img width="80%" src="ImgOriginal/HorrorSetup.jpeg">
        <h4>
            Gameplay video:
        </h4>
        <iframe width="80%" height="315" src="https://www.youtube.com/embed/I0Xlsjg1ZnM?si=yGekPzSs8EMaXk52" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </span>
  
</template>

<script>
export default {
    name:"Horror"

}
</script>

<style>

</style>